<button
  class="container diamond-shape"
  [ngClass]="{ selected: isSelected }"
  [attr.aria-label]="day + ' - ' + (isSelected ? 'Selected' : 'Not Selected')"
  (click)="reminderDay.emit(day)">
  <span class="day" aria-hidden="true">{{ dateTimeUtil.weekDaysData[day]?.shortName }}</span>
</button>
